// extracted by mini-css-extract-plugin
module.exports = {"rssStyle":"RssDirective_rssStyle__UaETl","muted":"RssDirective_muted__w8oIS"};